export const INSPECTION_VALUE_TYPE = {
	NUMERIC: "NUMERIC",
	TEXT: "TEXT",
	PASS_FAIL: "PASS_FAIL",
} as const;

const NUMERIC_PATTERN = /^-?\d+(\.\d+)?$/;
const PASS_FAIL_VALUES = ["O", "X"];

export const normalizeInspectionValue = (valueType: string, rawValue: unknown): string => {
	const value = String(rawValue ?? "").trim();
	return valueType.trim().toUpperCase() === INSPECTION_VALUE_TYPE.PASS_FAIL
		? value.toUpperCase()
		: value;
};

export const isValidInspectionValue = (valueType: string, value: string): boolean => {
	if (!value) return true;

	switch (valueType.trim().toUpperCase()) {
		case INSPECTION_VALUE_TYPE.NUMERIC:
			return NUMERIC_PATTERN.test(value);
		case INSPECTION_VALUE_TYPE.PASS_FAIL:
			return PASS_FAIL_VALUES.includes(value);
		case INSPECTION_VALUE_TYPE.TEXT:
			return true;
		default:
			return false;
	}
};

export const getInspectionValueValidationMessage = (valueType: string): string => {
	switch (valueType.trim().toUpperCase()) {
		case INSPECTION_VALUE_TYPE.NUMERIC:
			return "검사값은 숫자만 입력할 수 있습니다.";
		case INSPECTION_VALUE_TYPE.PASS_FAIL:
			return "합격/불합격은 O 또는 X로 입력해주세요.";
		case INSPECTION_VALUE_TYPE.TEXT:
			return "";
		default:
			return "지원하지 않는 검사값 유형입니다.";
	}
};

export const isNumericInspectionValueType = (valueType: string): boolean =>
	valueType.trim().toUpperCase() === INSPECTION_VALUE_TYPE.NUMERIC;
